import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ShieldAlert, LogIn } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ACT_KEY = 'pas_act';

const readAct = () => { try { return JSON.parse(localStorage.getItem(ACT_KEY) || 'null'); } catch { return null; } };

const endAct = async (expired) => {
  const token = localStorage.getItem('pas_client_token');
  if (!expired) await axios.post(`${API}/pas-auth/act/end`, {}, { headers: { Authorization: `Bearer ${token}` } }).catch(() => {});
  const prev = localStorage.getItem('pas_client_token_prev');
  if (prev) localStorage.setItem('pas_client_token', prev); else localStorage.removeItem('pas_client_token');
  localStorage.removeItem('pas_client_token_prev');
  localStorage.removeItem(ACT_KEY);
  window.location.href = '/pas/admin/dashboard';
};

// Red banner on every page while the admin is inside a subscriber's account
export const ActingBanner = () => {
  const [act, setAct] = useState(readAct);
  const [left, setLeft] = useState(0);
  useEffect(() => {
    const sync = () => setAct(readAct());
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, []);
  useEffect(() => {
    if (!act) return undefined;
    const tick = () => {
      const s = Math.max(0, Math.floor((new Date(act.expires_at) - Date.now()) / 1000));
      setLeft(s);
      if (!s) endAct(true);
    };
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [act]);
  if (!act || window.location.pathname.startsWith('/pas/admin')) return null;
  return (
    <div className="sticky top-0 z-[9000] bg-red-700 text-white px-4 py-2 flex flex-wrap items-center justify-center gap-3 text-sm print:hidden" data-testid="acting-banner">
      <ShieldAlert className="w-4 h-4" />
      <span>Admin acting as <b data-testid="acting-banner-email">{act.name || act.email}</b> ({act.email}). Every action is logged. No fees apply.</span>
      <span className="font-mono" data-testid="acting-banner-timer">{String(Math.floor(left / 60)).padStart(2, '0')}:{String(left % 60).padStart(2, '0')}</span>
      <button onClick={() => endAct(false)} className="px-3 py-1 bg-white text-red-700 rounded font-semibold" data-testid="acting-banner-exit">Exit account</button>
    </div>
  );
};

export const ActAsButton = ({ client, token }) => {
  const [busy, setBusy] = useState(false);
  const open = async () => {
    setBusy(true);
    try {
      const r = (await axios.post(`${API}/pas-admin/clients/${client.client_id}/act-as`, {}, { headers: { Authorization: `Bearer ${token}` } })).data;
      if (!readAct() && localStorage.getItem('pas_client_token')) localStorage.setItem('pas_client_token_prev', localStorage.getItem('pas_client_token'));
      localStorage.setItem('pas_client_token', r.token);
      localStorage.setItem(ACT_KEY, JSON.stringify({ email: r.client.email, name: r.client.name, expires_at: r.expires_at, act_id: r.act_id }));
      window.location.href = '/pas/dashboard';
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not open the account'); setBusy(false); }
  };
  return (
    <button onClick={open} disabled={busy} className="px-2 py-1 text-xs bg-red-600/80 hover:bg-red-600 text-white rounded flex items-center gap-1 whitespace-nowrap disabled:opacity-50" data-testid={`admin-act-as-${client.client_id}`}>
      <LogIn className="w-3 h-3" /> {busy ? 'Opening…' : 'Open account'}
    </button>
  );
};
